/** Dr. Jan Duffy — Calendly booking (15-minute private conversation). */
export const CALENDLY_SCHEDULE_URL =
  'https://calendly.com/drjanduffy/dr-duffy-private-15-min-conversation' as const;
